// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import Vuex from 'vuex'
import NoNameApi from './plugins/noname-api'
import Notifications from 'vue-notification'
import VuejsDialog from "vuejs-dialog"
import vSelect from 'vue-select'
import Vue2Storage from 'vue2-storage'
import VueCollapse from 'vue2-collapse'
import DatePicker from 'vue2-datepicker'
import VueI18n from 'vue-i18n'
import {messages} from "./localization/message";
import Vuelidate from 'vuelidate'
import VueCookie from 'vue-cookie'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(NoNameApi)
Vue.use(Notifications)
Vue.component('v-select', vSelect)
Vue.use(VueCollapse);
Vue.use(require('vue-moment'));
Vue.use(Vuelidate);
Vue.use(VueCookie);


if (VueCookie.get('locale') === null){
  VueCookie.set('locale', 'ru', { expires: 7 })
}

const i18n = new VueI18n({
  locale: VueCookie.get('locale'), // set locale
  messages // set locale messages
});

Vue.use(VuejsDialog,{ // use VuejsDialog.default if installing inside script tag
  html: true,
  okText: i18n.t('message.Да'),
  cancelText: i18n.t('message.Нет'),
})


Vue.use(Vue2Storage, {
    prefix: 'noname_',
    driver: 'local',
    ttl: 60 * 60 * 24 * 1000
})

import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import   './assets/themeforest/plugins/pace-master/themes/blue/pace-theme-flash.css';
import   './assets/themeforest/plugins/uniform/css/uniform.default.min.css';
import   './assets/themeforest/plugins/line-icons/simple-line-icons.css';
import   './assets/themeforest/plugins/offcanvasmenueffects/css/menu_cornerbox.css';
import   './assets/themeforest/plugins/waves/waves.min.css';
import   './assets/themeforest/plugins/switchery/switchery.min.css';
import   './assets/themeforest/plugins/3d-bold-navigation/css/style.css';
import   './assets/themeforest/plugins/slidepushmenus/css/component.css';
import   './assets/themeforest/plugins/weather-icons-master/css/weather-icons.min.css';
import   './assets/themeforest/plugins/metrojs/MetroJs.min.css';
import   './assets/themeforest/plugins/toastr/toastr.min.css';
import   './assets/themeforest/plugins/select2/css/select2.min.css';
import   './assets/themeforest/css/modern.css';
import   './assets/themeforest/css/themes/blue.css';

const store = new Vuex.Store({
    state: {
        menu: {
            menuItems: [
                {
                    id: 1,
                    name: i18n.t('message.Абоненты'),
                    url: '/accounts',
                    icon: 'fa-address-book',
                },
                {
                    id: 7,
                    name: i18n.t('message.Пакеты'),
                    url: 'packages',
                    icon: 'fa-tags '
                },
                {
                    id: 5,
                    name: i18n.t('message.Каналы'),
                    url: '/channels',
                    icon: 'fa-desktop'
                },
                {
                    id: 6,
                    name: i18n.t('message.Категории'),
                    url: '/categories',
                    icon: 'fa-folder'
                },
                {
                    id: 5,
                    name: i18n.t('message.Сервисы'),
                    url: '/services',
                    icon: 'fa-cogs',
                },
                {
                    id: 5,
                    name: i18n.t('message.Колокейшены'),
                    url: '/colocations',
                    icon: 'fa-project-diagram',
                },
                {
                    id: 10,
                    name: i18n.t('message.Источники_импорта'),
                    url: '/sources',
                    icon: 'fa-stream'
                },
                {
                    id: 30,
                    name: i18n.t('message.Видеотека'),
                    url: '#',
                    icon: 'fa-cubes',
                    childs: [
                        {
                            id: 31,
                            name: i18n.t('message.Видеотека'),
                            url: '/vod_movies'
                        },
                        {
                            id: 32,
                            name: i18n.t('message.Пакеты'),
                            url: '/vod_packages',
                            icon: 'fa-tags '
                        },
                        {
                            id: 33,
                            name: i18n.t('message.Жанры'),
                            url: '/vod_genres',
                            icon: 'fa-tags '
                        },
                        {
                            id: 34,
                            name: i18n.t('message.Сервисы'),
                            url: '/vod_services',
                            icon: 'fa-tags '
                        }    
                    ]
                },                
                {
                    id: 100,
                    name: i18n.t('message.Статистика'),
                    url: '/Statistics',
                    icon: 'fa-stream'
                },
                {
                    id: 100,
                    name: i18n.t('message.Apks'),
                    url: '/apks',
                    icon: 'fa-stream'
                },
                {
                    id: 20,
                    name: i18n.t('message.Администрирование'),
                    url: '#',
                    icon: 'fa-cubes',
                    childs: [
                        {
                            id: 21,
                            name: i18n.t('message.Пользователи'),
                            url: 'Users'
                        },
                        {
                            id: 22,
                            name: i18n.t('message.Роли'),
                            url: 'Roles'
                        }
                    ]
                },
            ]
        },
        TokenStorage : {
            Token : null
        }
        },
    mutations: {
        SET_TOKEN : (TokenStorage, payload) => {
            TokenStorage.TokenStorage.Token = payload;
        },
        ERASE_TOKEN : TokenStorage => {
            TokenStorage.TokenStorage.Token = null;
        }
        },
    getters : {
        IS_LOGIN : TokenStorage => {
            return TokenStorage.TokenStorage.Token != null;
            },
        ACCESS_TOKEN : TokenStorage => {
            return TokenStorage.TokenStorage.Token;
        },
    }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
  store,
  mounted() {
  }
})



// WEBPACK FOOTER //
// ./src/main.js